import React from "react";
import styled from "styled-components";
import { FormControlLabel, Checkbox } from "@material-ui/core";

const StyledCheckbox = styled(Checkbox)`
  && {
    color: ${({ theme }) => theme.colors.primary};
    svg {
      width: 13px;
      height: 13px;
    }
  }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    color: #999999;
    font-size: 14px;
    font-family: Lato;
    margin-left: -4px;
    user-select: none;
  }
`;

export const FormikCheckboxField = ({
    field,
    form,
    ...otherProps
}) => {
    return (
        <>
            <StyledFormControlLabel
                {...otherProps} 
                control={
                    <StyledCheckbox 
                        checked={field.value}
                        onClick={e => {
                            form.handleChange({
                                target: {
                                    name: field.name,
                                    value: !field.value
                                }
                            })
                        }}
                        name="rememberMe"
                    />
                }
                label={otherProps.label}
                labelPlacement="end"
            /> 
        </>
    );
};
